<template>
  <span class="bto-sb-mormarket-cell" v-if="getFilteredSortedOutcomes.length > 0">
    <component
      :is="match.isLiveMatch ? 'match-odd-live-details-component' : 'match-odd-component'"
      v-for="(outcome, idx) in showMoreOdds[match.tabs[this.tabIdx].odds[this.oddIdx].marketId] ?
            getFilteredSortedOutcomes : getFilteredSlicedSortedOutcomes"
      :key="idx"
      :match="match"
      :odd="odds[oddIdx]"
      :outcome="outcome"
      :isDetails="true"
      :isPrematch="!match.isLiveMatch"
      :lockEmptyOdd="false"
    />
  </span>
</template>

<script>
  import store from '@/store';
  import MatchOddComponent from '../../../common/match/match-odd-component';
  import MatchOddLiveComponent from '../../../common/match/match-odd-live-component';
  import MatchOddLiveDetailsComponent from '../../../common/match/match-odd-live-details-component';
  import OddHelperService from '../../../../services/odd-helper-service';

  export default {
    name: 'OddColumnComponent',
    data() {
      return {
        odds: [],
      };
    },
    components: {
      MatchOddComponent,
      MatchOddLiveComponent,
      MatchOddLiveDetailsComponent,
    },
    props: {
      match: {
        type: Object,
        required: true,
        default: () => { },
      },
      tabIdx: {
        type: Number,
        required: true,
        default: null,
      },
      oddIdx: {
        type: Number,
        required: true,
        default: null,
      },
      columnNo: {
        type: Number,
        required: true,
        default: null,
      },
      selectedMarket: {
        required: true,
        default: null,
      },
    },
    watch: {
      selectedMarket(val) {
        this.filterOdds(val);
      },
    },
    computed: {
      showMoreOdds() {
        return store.state.GlobalModule.showMoreOdds;
      },
      getFilteredSortedOutcomes() {
        if (this.selectedMarket === 'cashout') {
          const cashoutFiltered = this.match.tabs[this.tabIdx].odds.filter(o => o.cashout === true);
          return OddHelperService.orderColumnOutcomes(cashoutFiltered[this.oddIdx].outcomes, this.columnNo);
        }
        return OddHelperService.orderColumnOutcomes(this.match.tabs[this.tabIdx].odds[this.oddIdx].outcomes, this.columnNo, this.match.tabs[this.tabIdx].odds[this.oddIdx].isAutomaticSort);
      },
      getFilteredSlicedSortedOutcomes() {
        if (this.selectedMarket === 'cashout') {
          const cashoutFiltered = this.match.tabs[this.tabIdx].odds.filter(o => o.cashout === true);
          return OddHelperService.orderColumnOutcomes(cashoutFiltered[this.oddIdx].outcomes, this.columnNo);
        }

        if (this.marketIsCorrectScore(this.match.tabs[this.tabIdx].odds[this.oddIdx].marketId)) {
          return OddHelperService.orderColumnOutcomes(this.match.tabs[this.tabIdx].odds[this.oddIdx].outcomes, this.columnNo);
        }

        return OddHelperService.orderSlicedColumnOutcomes(this.match.tabs[this.tabIdx].odds[this.oddIdx].outcomes, this.columnNo, this.match.tabs[this.tabIdx].odds[this.oddIdx].isAutomaticSort);
      }
    },
    methods: {
      filterOdds(selectedMarket) {
        if (selectedMarket === 'cashout') {
          this.odds = this.match.tabs[this.tabIdx].odds.filter(o => o.cashout === true);
        } else {
          this.odds = this.match.tabs[this.tabIdx].odds;
        }
      },
      marketIsCorrectScore(marketId) {
        let prematchIds = [
          32, 391, 454, 455, 456, 457, 458, 453, 219,
          154, 403, 418, 416, 417, 385, 2, 388, 332,
          464, 337, 350, 71, 72, 450, 451, 452, 448, 449
        ];

        let liveIds = [
          10, 11, 12, 29, 40, 42, 107, 131, 132, 307,
          329, 335, 359, 360, 375, 379, 524, 623, 646, 685
        ];

        let correctScoreMarketIds = this.match.isLiveMatch ? liveIds : prematchIds;

        if (correctScoreMarketIds.includes(marketId)) {
          return true;
        }
        return false;
      },
    },
    created() {
      this.filterOdds(this.selectedMarket);
    }
  };
</script>
